export default {
  isAdvanced: null,
  async init(): Promise<void> {
    this.isAdvanced = false;
  },
};
